import React from 'react';
//import ReactDOM from "react-dom/client";
import preval from 'preval.macro'
import {
  Button,
  Col,
  Container,
  //Alert,
  //Nav,
  //Navbar,
  Row,
  Form,
  //Input,
  Stack
} from 'react-bootstrap';
import '../../App.css';
import utils from '../../utils'
import EcuComps2 from '../../comp/EcuComps2'
import MyCan from '../../MyCan';
import {MyCanUtils} from '../../MyCan'; // Ensure this path is correct
//import PTextLabel from '../../comp/p/PTextLabel'
//import { wait } from '@testing-library/user-event/dist/utils';
//////import { confirm } from "react-confirm-box";
// import AuthService from '../../services/auth-service';
import LoadingSpinner from "../../comp/gen/LoadingSpinner"
import UserAuthRequired from "../../comp/gen/UserAuthRequired"
import InfiniteScroll from 'react-infinite-scroll-component';

// ****************************************************************************

class EcuActions {
  constructor(ecu, setState) {
    this.ecu = ecu;
    this.setState = setState;
  }
  async readCans(onlyLastCanMessage, bitrate) {
    await this.setState({ ecu_comps: [] })
    this.ecu.readCans(onlyLastCanMessage, bitrate)
  }
  async setComPort() {
    await this.setState({ ecu_comps: [] })
    this.ecu.selectComPort()
  }
  stopCom() {
    console.log("stop pressed")
    this.ecu.stopComDone()
  }
}
function isObd2Message(item) {
  const id = item.Id;
  // Controlla se l'id rientra in uno dei range validi
  return (
    id === 0x7df ||
    (id >= 0x7e0 && id <= 0x7e7) ||
    (id >= 0x7e8 && id <= 0x7ef) ||
    id === 0x18db33f1 ||
    (id >= 0x18db33f2 && id <= (0x18db33f2 + 7)) ||
    (id >= 0x18daf110 && id <= (0x18daf110 + 7))
  ) 
}
function decodeObd2Message(item) {  
  var data = item.Data;
  // Ensure data is an array of bytes
  if (!Array.isArray(data) || data.length < 2) {
      return "Invalid data format";
  }
  // The first byte indicates the length of the payload
  const payloadLength = data[0];
  // Validate the payload length
  if (payloadLength + 1 > data.length) {
      return "Invalid payload length";
  }
  // Extract the payload based on the length
  const payload = data.slice(1, 1 + payloadLength);
  // Convert the payload to a hex string
  const hexData = payload.map(byte => byte.toString(16).padStart(2, '0')).join('');
  // Extract mode and PID
  const mode = hexData.substring(0, 2);
  const pid = hexData.substring(2, 4);
  // Decode based on mode and PID
  if (mode === "41") { // Positive response for OBD-II Request
    var t = `OBD2 Response (mode 1) PID ${pid}`
    if (pid === "0C" && payload.length >= 4) { // RPM motore
      const A = payload[2]; // Byte 3
      const B = payload[3]; // Byte 4
      const rpm = ((A * 256) + B) / 4;
      return `${t} --- Engine RPM: ${rpm} rpm`;
    } else if (pid === "0D" && payload.length >= 3) { // Velocità veicolo
      const speed = payload[2]; // Byte 3
      return `${t} --- Vehicle Speed: ${speed} km/h`;
    } else if (pid === "05" && payload.length >= 3) { // Temperatura liquido di raffreddamento
      const A = payload[2]; // Byte 3
      const temp = A - 40; // Formula standard
      return `${t} --- Engine Coolant Temperature: ${temp} °C`;
    } else if (pid === "06" && payload.length >= 3) { // Correttore veloce (Short Term Fuel Trim)
      const A = payload[2]; // Byte 3
      const stft = ((A - 128) * 100) / 128;
      return `${t} --- Short Term Fuel Trim: ${stft.toFixed(1)}%`;
    } else if (pid === "07" && payload.length >= 3) { // Correttore lento (Long Term Fuel Trim)
      const A = payload[2]; 
      const ltft = ((A - 128) * 100) / 128;
      return `${t} --- Long Term Fuel Trim: ${ltft.toFixed(1)}%`;
    } else {
      return t;
    }
  } else if (mode === "01") {
    var t = `OBD2 Request (mode 1) PID ${pid}`
    return t;
  } else if (mode === "03") {
    return "OBD2 DTC Request (mode 3)";
  } else if (mode === "43") { 
    return "OBD2 DTC Response (mode 3)";
  } else if (mode === "07") {
    return "OBD2 DTC Request (mode 7)";
  } else if (mode === "47") {
    return "OBD2 DTC Response (mode 7)";
  } else if (mode === "04") {
    return "OBD2 Clear DTC command (mode 4)";
  }
  return "Unknown OBD2 message";
}
const MAX_CAN_MESSAGES = 500; // Numero massimo di messaggi da mantenere
export default class MP_CAN_LOGGER extends React.Component {
  constructor(props) {
    super(props); 
    this.ecu = new MyCan()
    this.ecu.progressChanged = this.ecu_progress_changed.bind(this)
    this.ecu.comPortChanged = this.ecu_com_port_changed.bind(this)
    this.ecu.cansUpdated = this.cansUpdated.bind(this)
    this.ecuActions = new EcuActions(this.ecu, this.setState.bind(this));
    
    this.state = { 
      stay_in_boot_after_fix_checked: false,
      working: 0,
      ecu_comps: [],            
      usb_selected: false,
      can_messages: [],
      _program_block_progress: "0.0%",
      onlyLastCanMessage: false, // Nuovo stato per la checkbox
      bitrate: 1, // Default: 500 kbit/s
    };
    if ("serial" in navigator) {
      console.log("supported !") 
    }
  }
  ecu_com_port_changed(o) {
    if (o === undefined) {
      this.setState({
        usb_selected: false,
      })
      return 
    }
    this.setState({
      usb_selected: true,
    })
  }
  ecu_progress_changed(o) {
    if (o.type === "_working") {
      this.setState({
        working: o.data        
      })
    } else if (o.type === "_program_block") {
      ////////console.log(o.data)
      this.setState({
        _program_block_progress: (100.0 * o.data.pos / o.data.size).toFixed(1) + "%"
      })
    } else {
      this.setState(prevState => ({
        ecu_comps: [
          ...prevState.ecu_comps,
          o,
        ]
      }))
    }    
    //console.log("STATE")
    //console.log(this.state)
  }
  handleOnlyLastCanMessageChange = (e) => { this.setState({ onlyLastCanMessage: e.target.checked }) }  
  async handleSaveToFile() {
    const messages = this.state.can_messages.map(item => {
      const formattedTime = new Date(item.local_timestamp).toLocaleTimeString('it-IT', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3,
      });
      return `[${formattedTime}] ${MyCanUtils.HEX(item.Id, 8)}   ${MyCanUtils.B_HEX(item.Data)}`;
    });
  
    const blob = new Blob([messages.join('\n')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement('a');
    a.href = url;
    a.download = 'can_messages.txt';
    a.click();
  
    URL.revokeObjectURL(url); // Libera la memoria
  }  
  async cansUpdated(can_messages) {
    //var cans_strings = can_messages.toStrings()
    //console.log(can_messages)
    var a = can_messages.toArray();
    //Limita il numero di messaggi
    if (a.length > MAX_CAN_MESSAGES) {
      a = a.slice(-MAX_CAN_MESSAGES); // Mantieni solo gli ultimi MAX_CAN_MESSAGES
    }
    await this.setState({ can_messages: a })
  }
  render() { 
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    if (!utils.userHasRole(this.props.authStatus.user, "CANLOG")) return <UserAuthRequired notallowed />

    var buttons_en = !(this.state.working === 1)  
    var height = "calc(100vh - " + this.props.navbarHeight + ")"  
    return (
      <>          
        <Container fluid style={{ border: '0px solid gray', height: height, overflow: 'hidden' }}>
          <Row style={{ height: '100%', marginBottom: "15px" }}>             
            <Col md={3}>
              <Stack gap={3}>
                <Button 
                    variant="outline-secondary" 
                    disabled={!buttons_en}  
                    onClick={e => this.ecuActions.setComPort()}>SET COM PORT</Button>
                <Form.Select
                  aria-label="Select CAN bitrate"
                  value={this.state.bitrate}
                  onChange={(e) => this.setState({ bitrate: parseInt(e.target.value) })} >
                    <option value={0}>250 kbit/s</option>
                    <option value={1}>500 kbit/s</option>
                    <option value={2}>1 Mbit/s</option>
                </Form.Select>
                <br />
                <Button 
                    variant="success" 
                    disabled={!buttons_en} 
                    onClick={e => this.ecuActions.readCans(this.state.onlyLastCanMessage, this.state.bitrate)}>START</Button>
                <Button 
                  variant="info" 
                  onClick={e => this.ecuActions.stopCom()}>STOP</Button>   
                <Form.Check 
                    type="checkbox"
                    label="Only Last Message"
                    checked={this.state.onlyLastCanMessage}
                    onChange={this.handleOnlyLastCanMessageChange} />
                <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  Messaggi CAN: {this.state.can_messages.length} / {MAX_CAN_MESSAGES}
                </p>              
                <Button 
                  variant="primary" 
                  onClick={e => this.handleSaveToFile()}>Save to File</Button>  
              </Stack>
              <Stack gap={3} style={{ marginTop: "15px" }}>
                <EcuComps2 ecu_comps={this.state.ecu_comps} />
              </Stack>                
            </Col> 
            <Col md={9} style={{ border: '0px solid gray' }}>      
              <InfiniteScroll
                dataLength={this.state.can_messages.length} // Lunghezza della lista
                next={() => {}} // Funzione per caricare più dati (non necessaria se hai già tutti i dati)
                hasMore={false} // Imposta su `false` se non hai più dati da caricare
                height={height} // Altezza visibile
                loader={<h4>Loading...</h4>} >
                {this.state.can_messages
                  .slice()
                  .reverse()
                  .map((item, index) => {
                    const formattedTime = new Date(item.local_timestamp).toLocaleTimeString('it-IT', {
                      hour12: false,
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                      fractionalSecondDigits: 3,
                    });

                    return (
                      <pre key={index} style={{ marginBottom: '2px' }}>
                        <span style={{ color: '#000' }}>
                          [{formattedTime}]
                        </span>
                        <span style={{ fontWeight: 'bold', color: item.color || '#000' }}>
                          &nbsp;&nbsp;{MyCanUtils.HEX(item.Id, 8)}
                        </span>
                        <span style={{ color: '#000' }}>
                          &nbsp;&nbsp;{MyCanUtils.B_HEX(item.Data)}
                        </span>
                        <span style={{ color: '#555', fontStyle: 'italic' }}>
                          &nbsp;&nbsp;{ isObd2Message(item) ? decodeObd2Message(item) : "" }
                        </span>
                      </pre>
                    );
                  })}
              </InfiniteScroll>
            </Col>
          </Row>
        </Container>        
      </>
    )
  }
}
